module.exports = __webpack_public_path__ + "static/media/marvelous_07.d9df4486.jpg";